import { useNavigate } from "react-router-dom";
import { GoogleSignInButton } from "@/components/auth/GoogleSignInButton";
import { SignUpForm } from "@/components/auth/SignUpForm";

const Auth = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate("/login");
  };

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-r from-[#ECFDF5] to-white">
      <main className="flex-grow flex items-center justify-center px-4">
        <div className="w-full max-w-[448px] bg-white rounded-2xl shadow-[0px_4px_6px_rgba(0,0,0,0.1),0px_10px_15px_rgba(0,0,0,0.1)] p-8">
          <div className="text-center mb-12">
            <h2 className="text-2xl font-bold text-[#111827] mb-2">Welcome to Kosi</h2>
            <p className="text-[#4B5563]">Enter your details to continue</p>
          </div>

          <SignUpForm />

          <div className="mt-8">
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-[#D1D5DB]" />
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-white text-[#6B7280]">Or continue with</span>
              </div>
            </div>

            <GoogleSignInButton />
          </div>
        </div>
      </main>

      <div className="text-center py-2">
        <p className="text-lg font-medium">
          Already have an account?{" "}
          <button
            onClick={handleLoginClick}
            className="text-lg font-semibold text-[#059669] hover:underline hover:text-[#047857] transition-colors"
          >
            Log in here
          </button>
        </p>
        <p className="text-base text-[#4B5563]">Need help? Contact our support at info@get-kosi.com</p>
      </div>
    </div>
  );
};

export default Auth;